import { MDBCheckbox, MDBChip, MDBInput, MDBTextArea } from "mdb-react-ui-kit";
import React from "react";

function NumbersNotification({
  register,
  errors,
  watch,
  setValue,
  clearErrors,
}) {
  return (
    <>
      <div className="pb-3">
        <h5>Notifications and Additional Comments</h5>
        <div className="w-30">
          <div className="tel-numbers mt-2">
            <strong>Your Contact Phone Number*</strong>
          </div>
          <MDBInput
            type="text"
            value={watch("notifs_comments.contact_ph_num")}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            onChange={(e) => {
              if (e.target.value === "") {
                setValue("notifs_comments.contact_ph_num", e.target.value, {
                  shouldDirty: true,
                });
              } else {
                setValue(
                  "notifs_comments.contact_ph_num",
                  parseInt(e.target.value),
                  {
                    shouldDirty: true,
                  }
                );
              }
              clearErrors("notifs_comments.contact_ph_num");
            }}
          />
          {errors?.notifs_comments?.contact_ph_num && (
            <p className="text-danger">
              {errors?.notifs_comments?.contact_ph_num?.message}
            </p>
          )}
        </div>
        <small>
          Enter a number where we can call you if there is a problem with the
          port request
        </small>
        <div className="tel-numbers mt-2">
          <strong>Send Emails to</strong>
        </div>
        {/* <div className="border p-2 mb-2">
          <div className="d-flex mb-2">
            <MDBChip closeIcon>kajal@email.beta-wspbx.com</MDBChip>
          </div>
          <MDBInput />
        </div> */}
        <MDBTextArea
          id="textAreaExample"
          rows={4}
          value={watch("notifs_comments.email")}
          placeholder="Enter email address"
          maxLength={500}
          onChange={(e) => {
            setValue("notifs_comments.email", e.target.value, {
              shouldDirty: true,
            });
            clearErrors("notifs_comments.email");
          }}
        />
        {errors?.notifs_comments?.email && (
          <p className="text-danger">
            {errors?.notifs_comments?.email?.message}
          </p>
        )}
        Use "," to seperate multiple email addresses.
        <div className="tn-checkbox">

          {/* <div className="d-flex align-items-center">
            <label
              className={`big-checkbox d-flex align-items-center lh-normal ${watch('notifs_comments.send_email_to_admin') ? 'checked' : ''
                }`}
            >
              <input
                type="checkbox"
                id="flexCheckDefault5"
                name="flexCheck"
                checked={watch('notifs_comments.send_email_to_admin') ?? false}
                onChange={(e) =>
                  setValue('notifs_comments.send_email_to_admin', e.target.checked, {
                    shouldDirty: true,
                  })
                }
              />
              <span className="box me-2">
                <svg
                  className="checkmark"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.7071 8.70711L10.5 16.9142L6.29289 12.7071L7.70711 11.2929L10.5 14.0858L17.2929 7.29289L18.7071 8.70711Z"
                    fill="#FFFFFF"
                  />
                </svg>
              </span>
              Send emails to system admin user
            </label>
          </div> */}


          <div className="d-flex align-items-center">
            <MDBCheckbox
              id="flexCheckDefault5"
              name="flexCheck"
              label="Send emails to system admin user"
              checked={watch('notifs_comments.send_email_to_admin') ?? false}
              onChange={(e) =>
                setValue('notifs_comments.send_email_to_admin', e.target.checked, {
                  shouldDirty: true,
                })
              }
              className={`big-checkbox lh-normal ${watch('notifs_comments.send_email_to_admin') ? 'checked' : ''}`}
            />
          </div>
        </div>
        <div className="tel-numbers mt-2">
          <strong>
            Additional Comments ({watch("notifs_comments.comments").length} /
            500)
          </strong>
        </div>
        <MDBTextArea
          id="textAreaExample"
          rows={4}
          value={watch("notifs_comments.comments")}
          placeholder="Enter your comments"
          maxLength={500}
          onChange={(e) => {
            setValue("notifs_comments.comments", e.target.value, {
              shouldDirty: true,
            });
            clearErrors("notifs_comments.comments");
          }}
        />
        <small className="d-block mt-2">
          If you are not transferring all of your phone numbers in the same
          billing Account Number, please list the remaining phone numbers here
          and the action to be taken for each phone number(Remain, disconnect,
          etc.) Please provide any additional information and the instructions
          to support a successful porting experience.
        </small>
      </div>
    </>
  );
}

export default NumbersNotification;
